<template>

  <div>
    <b-message >
      <b>{{title}}</b>
    </b-message>

    <section class="container" v-if="!isLoading">

      <teams-table
        :teams="teams"
        :game="game"
        @displayErrors="displayErrors"
        @displaySuccess="displaySuccess"
        @refreshTeams="refreshTeams"
      />

    </section>
    <button
      class="button is-light btn-margin"
      @click.prevent="cancel()"
    >
      Back to games list
    </button>
    <button @click="openTeamCreator" v-if="!isGameStopped(game)"  class="button is-primary">Create a new team</button>
    <b-loading :is-full-page="true" :active.sync="isLoading" :canCancel="true"></b-loading>
  </div>

</template>

<script>
  import teamsService from '../services/teamsService'
  import gamesService from '../services/gamesService'
  import TeamsTable from './single/TeamsTable'
  import PictureInput from 'vue-picture-input'
  import displayHelper from '../helpers/display-helper'
  import gameHelper from '../helpers/game-helper'

  export default {
    data() {
      return {
        teams: [],
        teamName: '',
        password: '',

        isLoading: true,

        photoToUpload: null,
        photoUploaded: false,
        gameId: '',
        game: {},
        title: 'Teams'
      }
    },
    components: {
      TeamsTable,
      PictureInput
    },
    async created() {
      try {
        if (this.$route.params.id) {
          this.gameId = this.$route.params.id
          this.game = await gamesService.getGameById(this.gameId)

          console.dir(this.game)

          this.teams = await teamsService.getTeams(this.gameId)
          this.displayTitle()
          this.isLoading = false
        } else {
          displayHelper.displayError(this, 'GameId was not found in URL')
          console.log('GameId was not found in URL')
        }
      } catch (err) {
        displayHelper.displayError(this, 'Failed to display teams - please contact support')
        console.log('Failed to display teams')
      }
    },
    methods: {
      isGameStopped: gameHelper.isGameStopped,
      displayErrors(errors) {
        displayHelper.displayError(this, 'Error:' + errors.join())
      },
      displaySuccess(message) {
        displayHelper.displaySuccess(this, message)
      },
      openTeamCreator() {
        this.$router.push(`teams/create`)
      },
      displayTitle() {
        this.title = `Teams for game: ${this.game.gameName}`
      },
      cancel() {
        this.$router.go(-1)
      },
      async refreshTeams() {
        try {
          this.teams = await teamsService.getTeams(this.gameId)
        } catch (err) {
          displayHelper.displayError(this, 'Failed to refresh team list')
        }
      }
    }
  }
</script>

<style scoped>
.cell--profile-picture img {
  max-width: 60px;
  max-height: 60px;
  border-radius: 50%;
}
.container {
  margin-right: 20px;
}
.container {
  display: flex;
}
.container > * {
  flex: 1;
}
.btn-margin {
  margin-left: 10px;
  margin-right: 10px;
}

</style>
